import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import { USER_INFO, HttpSetting } from "./state";
import { UserInfoProps } from "@/store";
import { message as antMessage } from 'antd';
import { clearUserLoginInfo } from "@/utils/login";
// 请求超时时间
const DefaultTimeOut = 30 * 1000
export const service = axios.create({
    // baseURL: "http://onlinecs.vaiwan.cn/api/",
    baseURL: `${HttpSetting.httpBaseURL}/api/`,
    timeout: DefaultTimeOut, // 请求超时时间
    maxBodyLength: Infinity, //设置适当的大小
    // httpsAgent: new https.Agent({rejectUnauthorized: false}), // 忽略 HTTPS 错误
})

// request拦截器,拦截每一个请求加上请求头
service.interceptors.request.use(
    (config:any) => {
        config.baseURL = config.diyHome ? `${config.diyHome}/api/` : `${HttpSetting.httpBaseURL}/api/`
        if (USER_INFO.isLogin && USER_INFO.token) config.headers["Authorization"] = USER_INFO.token
        // console.log('request-config',config);
        return config
    },
    (error) => {
        Promise.reject(error)
    }
)

// respone拦截器 拦截到所有的response，然后先做一些判断
service.interceptors.response.use(
    (response) => {
        const res = {
            code: response.status,
            data: response.data
        }
        // console.log("response__1", response)
        return res as any
    },
    (error) => {
        // console.log("error_1", error)
        if (error.response && error.response.data && error.response.data.message === "token过期") {
            const res = {
                code: 401,
                message: error.response.data.message,
                userInfo: USER_INFO
            }
            return Promise.resolve(res)
        }
        if (error.response && error.response.status === 401) {
            const res = {
                code: 401,
                message: error.response.data.reason,
                userInfo: USER_INFO
            }
            return Promise.resolve(res)
        }
        if (error.response && error.response.data && error.response.data.code === 401) {
            const res = {
                code: 401,
                message: error.response.data.message,
                userInfo: USER_INFO
            }
            return Promise.resolve(res)
        }
        if (error.response) {
            return Promise.resolve(error.response.data)
        }
        return Promise.reject(error)
    }
)

export const httpApi = (method:string, url:string, params:any, headers:any, isAddParams = true,timeout = DefaultTimeOut) => {
    if (!["get", "post"].includes(method)) {
        return Promise.reject(`call yak echo failed`)
    }
    return service({
        url,
        method,
        headers,
        params: isAddParams ? params : undefined,
        data: method === "post" ? params : undefined,
        timeout
    })
}

interface AxiosResponseInfoProps {
    message?: string
    reason?: string
    userInfo?: UserInfoProps
}

// 批量覆盖
type Merge<M, N> = Omit<M, Extract<keyof M, keyof N>> & N

type AxiosResponseProps<T = any, D = any> = Merge<
    AxiosResponse<T, D>,
    {
        code?: number
        message?: string
    }
>

export interface requestConfig<T = any> extends AxiosRequestConfig<T> {
    params?: T
    /** @name 自定义接口域名 */
    diyHome?: string
}

export function NetWorkApi<T, D>(params: requestConfig<T>): Promise<D> {
    return new Promise((resolve, reject) => {
        // console.log("request-params", params)
            service(params)
            .then((res) => {
                handleAxios(res, resolve, reject)
            })
            .catch((err: any) => {
                // console.log("request-err", err)
                reject(err)
            })
    })
}

export const handleAxios = (res: AxiosResponseProps<AxiosResponseInfoProps>, resolve, reject) => {
    const {code, message, data} = res
    // console.log("返回", res)
    if (!code) {
        reject("请求超时，请重试")
        return
    }
    switch (code) {
        case 200:
            resolve(data)
            break
        case 209:
            reject(data.reason)
            break
        case 401:
            tokenOverdue(res)
            reject(message)
            break
        default:
            reject(message)
            break
    }
}

// token过期，退出
const tokenOverdue = async(res) => {
    antMessage.error("401,登录过期/未登录，请重新登录")
    clearUserLoginInfo(true)
}
